import {PermissionCheckerService} from 'abp-ng2-module';
import {AppSessionService} from '@axilla/axilla-shared';

import {AppConsts} from '@shared/AppConsts';
import {Injectable} from '@angular/core';
import {AppMenu} from './app-menu';
import {AppMenuItem} from './app-menu-item';

import {
    CategoryDto,
    OrderGuideSimpleDto,
    PagedResultDtoOfCategoryDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';

import {catchError, combineLatestWith, debounceTime, map, take, tap, filter} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, Observable, throwError} from 'rxjs';

import {OrderGuideService} from '@app/shared/common/shop-system/services/order-guide.service';
import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';

@Injectable({
    providedIn: 'root',
})
export class AppNavigationService {
    categoriesForUserMenuItem = new AppMenuItem('Menu.CategoriesForUser', '', '', '', [], undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);

    private combinedMenuSubject: BehaviorSubject<AppMenu>;
    get combinedMenu$(): Observable<AppMenu> {
        return this.combinedMenuSubject.asObservable();
    }
    get combinedMenu(): AppMenu {
        return this.combinedMenuSubject.getValue();
    }

    private categoriesMenuSubject: BehaviorSubject<AppMenuItem>;
    get categoriesMenu$(): Observable<AppMenuItem> {
        return this.categoriesMenuSubject.asObservable();
    }
    get categoriesMenu(): AppMenuItem {
        return this.categoriesMenuSubject.getValue();
    }

    private defaultMenuSubject: BehaviorSubject<AppMenu>;
    get defaultMenu$(): Observable<any> {
        return this.defaultMenuSubject.asObservable();
    }

    defaultMenu: AppMenu = this.getBaseMenu();

    orderGuideSubscription$;
    orderGuideMenuItems = new AppMenuItem('Axilla.Menu.PunchOut', '', '', '', [], undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);

    //#region PunchOut

    get isGuided(): boolean {
        const guidedUser = this._permissionCheckerService.isGranted(BasePermissionDefinition.Webshop.View.Guided);
        return guidedUser && !!abp.session.impersonatorUserId;
    }

    constructor(
        private readonly _permissionCheckerService: PermissionCheckerService,
        private readonly _appSessionService: AppSessionService,
        private readonly _webshopServiceProxy: WebShopServiceProxy,
        private readonly _webshopService: WebshopService,
        private readonly _fieldAgentOrderService: FieldAgentOrderService,
        private readonly _orderStateService: OrderStateService
    ) {
        this.combinedMenuSubject = new BehaviorSubject<AppMenu>(this.defaultMenu);
        this.defaultMenuSubject = new BehaviorSubject<AppMenu>(this.defaultMenu);
        this.categoriesMenuSubject = new BehaviorSubject<AppMenuItem>(undefined);

        if (this.isGuided) {
            combineLatest([
                this._fieldAgentOrderService.selectedOrderGuideTemplate$,
                this._fieldAgentOrderService.selectedBrand$,
                this.categoriesMenuSubject.asObservable(),
            ])
                .pipe(
                    debounceTime(1000), // Applies to the combined emissions
                    filter(([orderGuideTemplate, selectedBrand]) => orderGuideTemplate !== undefined && selectedBrand !== undefined),
                    tap(([orderGuideTemplate, selectedBrand, item]) => {
                        let menu = this.getBaseMenu();

                        // Add category menu item if it exists
                        if (item) {
                            menu.items.push(item);
                        }

                        // Add "Select Product" menu if selectedBrand exists
                        if (selectedBrand) {
                            const selectProductMenuItem = new AppMenuItem(
                                'Select Product',
                                '',
                                undefined,
                                `/app/webshop/articles/${selectedBrand.id}`,
                                undefined, undefined, undefined, () => {
                                    if (!this._fieldAgentOrderService.selectedBrand
                                        || !this._fieldAgentOrderService.selectedOrderGuideTemplate) {
                                        return false;
                                    }

                                    return !this._orderStateService.isSelectPromotionState
                                        && !this._orderStateService.isVerifyPromotionState
                                        && !this._orderStateService.isConfirmOrderState
                                        && !this._orderStateService.isOrderSubmitedState;
                                }, undefined, undefined, undefined, undefined, undefined, 'order-guide-nav'
                            );
                            menu.items.push(selectProductMenuItem);
                        }

                        // Handle order state for promotion
                        const selectPromotionMenuItem = new AppMenuItem(
                            'Select Promotion',
                            '',
                            undefined,
                            `/app/webshop/field-agent/promotion`,
                             undefined, undefined, undefined, () => {
                                return this._orderStateService.isSelectPromotionState
                                    || this._orderStateService.isVerifyPromotionState;
                            }
                        );
                        menu.items.push(selectPromotionMenuItem);

                        this.combinedMenuSubject.next(menu);
                    })
                )
                .subscribe({
                    next: () => {},
                    error: (err) => console.error('Error in combined stream:', err),
                });
        } else {
            this.categoriesMenuSubject.asObservable()
                .pipe(
                    tap((item: AppMenuItem) => {
                            const selectedBrand = this._fieldAgentOrderService.selectedBrandValue;
                            if (selectedBrand) {
                                const selectProductMenuItem = new AppMenuItem('Select Product',
                                    '',
                                    undefined,
                                    `/app/webshop/articles/${selectedBrand.id}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'order-guide-nav');

                                let menu = this.getBaseMenu();
                                menu.items.push(selectProductMenuItem);
                                if (item) {
                                    menu.items.push(item);
                                }
                                this.combinedMenuSubject.next(menu);
                            }
                        }
                    ))
                .subscribe();
        }

        // if (this.isGuided) {
        //     this._fieldAgentOrderService.selectedOrderGuideTemplate$
        //         .pipe(
        //             combineLatestWith(this._fieldAgentOrderService.selectedBrand$),
        //             debounceTime(1000), // Applies to the combined emission
        //             filter(([orderGuideTemplate, selectedBrand]) => orderGuideTemplate !== undefined && selectedBrand !== undefined),
        //             tap(([orderGuideTemplate, selectedBrand]) => {
        //                 // const selectedBrandDto = selectedBrand as OrderGuideSimpleDto;
        //                 // const selectProductMenuItem = new AppMenuItem(
        //                 //     'Select Product',
        //                 //     '',
        //                 //     undefined,
        //                 //     `/app/webshop/articles/${selectedBrandDto.id}`,
        //                 //     undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'order-guide-nav'
        //                 // );
        //                 //
        //                 // let menu = this.getBaseMenu();
        //                 // menu.items.push(selectProductMenuItem);
        //                 //
        //                 // if (this.categoriesMenu) {
        //                 //     menu.items.push(this.categoriesMenu);
        //                 // }
        //                 //
        //                 // this.combinedMenuSubject.next(menu);
        //             })
        //         )
        //         .subscribe({
        //             next: () => {},
        //             error: (err) => console.error('Error in combined stream:', err),
        //         });
        //
        //     this._orderStateService.currentState$
        //         .pipe(
        //             tap((state) => {
        //                 if (this._orderStateService.isSelectPromotionState
        //                     || this._orderStateService.isVerifyPromotionState) {
        //
        //                     const selectPromotionMenuItem = new AppMenuItem(
        //                         'Select Promotion',
        //                         '',
        //                         undefined,
        //                         `/app/webshop/field-agent/promotion`
        //                     );
        //
        //                     let menu = this.getBaseMenu();
        //                     menu.items.push(selectPromotionMenuItem);
        //
        //                     if (this.categoriesMenu) {
        //                         menu.items.push(this.categoriesMenu);
        //                     }
        //
        //                     this.combinedMenuSubject.next(menu);
        //                 } else {
        //                     console.log('state', state);
        //                 }
        //
        //             })
        //         )
        //         .subscribe();
        // }


    }

    getBaseMenu(): AppMenu {
        let menu = [
            new AppMenuItem('Axilla.Menu.Dashboard', '', '', '/app/webshop/dashboard', undefined, undefined, undefined, () => {
                return !this.isGuided;
            }),
            new AppMenuItem('Axilla.Menu.Orders', 'Pages.App.PunchOut.Order', '', '/app/webshop/order-overview'),
        ];
        if (this.isGuided) {
            menu.unshift(new AppMenuItem('Axilla.Menu.Home', BasePermissionDefinition.Webshop.View.Guided, '', '', undefined, undefined, undefined, undefined, undefined, true, undefined, BtnActions.GuidedHome));
        }
        return new AppMenu('MainMenu', 'MainMenu', menu);
    }

    //new appmenu item localized menu name, permission, icon, route
    getMenu(): AppMenu {
        this._onOrderGuide();

        return this.getDefaultOrLowMenu();
    }

    getPunchOutShopMenu(): AppMenu {
        return null;

    }

    //get menu depends on UblionBase Feature
    getDefaultOrLowMenu(): AppMenu {
        this.categoriesForUserMenuItem.items.forEach(x => {
            this.defaultMenu.items.push(x);
        });

        return this.defaultMenu;
    }

    //#endregion PunchOut

    getCategories(appItem: AppMenuItem) {
        return this._webshopServiceProxy.getCategoriesOverview()
            .subscribe((listResultDtoOfCategories: PagedResultDtoOfCategoryDto) => {
                    const listItems = listResultDtoOfCategories.items.map((value: CategoryDto) => {
                        const item = new AppMenuItem(value.name,
                            '',
                            '',
                            '',
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            null,
                            true);
                        return item;
                    });

                    appItem.items.push(...listItems);

                },
                (err) => {
                    return throwError(err);
                });
    }

    getCombinedMenu(): AppMenu {
        let menu = this.getMenu();
        return menu;
    }

    getRightMenu(): AppMenu {
        let supportLink = '/';
        let apiLink = `${AppConsts.remoteServiceBaseUrl}/swagger/index.html`;

        let menu = new AppMenu('RightMenu', 'RightMenu', [
            new AppMenuItem('Pages.Beta.Menu.ApiLogin', null, null, apiLink, undefined, true, undefined, () => {
                return abp.features.isEnabled('App.Beta.Menu.ApiLogin');
            }),
            new AppMenuItem('Pages.Beta.Menu.Support', null, null, supportLink, undefined, undefined, undefined, () => {
                return abp.features.isEnabled('App.Beta.Menu.Support');
            })
        ]);
        return menu;
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null || subMenuItem.permissionName && this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            } else if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach(menuItem => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private _onOrderGuide() {
        this.orderGuideSubscription$ = this._webshopService.orderGuides$
            .pipe(
                take(1),
                map((item: OrderGuideSimpleDto[]) => {
                    //if (this._permissionCheckerService.isGranted('Pages.App.PunchOut.Order')) {
                    const listItems = item.map((value: OrderGuideSimpleDto) => {
                        const id = value.id;
                        const item = new AppMenuItem(value.name,
                            '',
                            undefined,
                            `/app/webshop/articles/${id}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'order-guide-nav');

                        return item;
                    });
                    const og = new AppMenuItem('Order Guides',
                        undefined,
                        undefined, undefined, listItems, undefined, undefined, () => {
                            return !this.isGuided
                        });

                    this.defaultMenu.items.push(og);
                    this._initCategoryMenu();
                    //}
                }),
                catchError((err) => {
                    return throwError(err);
                })
            )
            .subscribe();
    }

    private _initCategoryMenu() {
        this._webshopServiceProxy.getCategoriesOverview()
            .pipe(
                take(1),
                map((result: PagedResultDtoOfCategoryDto) => {
                    const listItems = result.items.filter(x => x.level === 0).map((value: CategoryDto) => {
                        const id = value.id;
                        const item = new AppMenuItem(value.name,
                            '',
                            undefined,
                            `/app/webshop/categories/${id}`,
                            undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'category-nav');

                        return item;
                    });
                    const category = new AppMenuItem('Categories',
                        undefined,
                        undefined, undefined, listItems, undefined, undefined, () => {
                            return !this.isGuided;
                        });

                    this.categoriesMenuSubject.next(category);
                    this.defaultMenu.items.push(category);
                }),
                catchError((err) => {
                    return throwError(err);
                })
            )
            .subscribe();
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach(subMenu => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}

export enum BtnActions {
    Recras = 1,
    EcxactOnline,
    GuidedHome
}
